import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import BarChart from "../../../../components/UI/Chart/barchart";
import NoSearchResult from "../../../../components/Common/NoSearchResult";

interface BarChartCardProps {
  title: string;
  categories: string[];
  seriesData: number[];
  seriesName: string;
}

const BarChartCard: React.FC<BarChartCardProps> = ({ title, categories, seriesData, seriesName }) => {
  return (
    <Card>
      <CardHeader>
        <h4 className="card-title mb-0">{title}</h4>
      </CardHeader>
      <CardBody>
        {seriesData.length > 0 ? (
          <BarChart categories={categories} seriesData={seriesData} seriesName={seriesName} />
        ) : (
          <NoSearchResult text="No data" />
        )}
      </CardBody>
    </Card>
  );
};

export default BarChartCard;
